import { faKey } from "@fortawesome/free-solid-svg-icons/faKey";
export let iconPublicKey = faKey;
export function overwritePublicKey(icon) {
    iconPublicKey = icon;
}
export default iconPublicKey;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHVibGljS2V5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3B1YmxpY0tleS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0seUNBQXlDLENBQUM7QUFFaEUsTUFBTSxDQUFDLElBQUksYUFBYSxHQUFHLEtBQUssQ0FBQztBQUVqQyxNQUFNLFVBQVUsa0JBQWtCLENBQUMsSUFBb0I7SUFDckQsYUFBYSxHQUFHLElBQUksQ0FBQztBQUN2QixDQUFDO0FBRUQsZUFBZSxhQUFhLENBQUMifQ==